import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  NavLink
} from 'react-router-dom'

import TabbedView from './TabbedView'
import Breadcrumb from './components/Breadcrumb'
import './index.css'

import Logo from './assets/logo.svg'

import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
  <Router>
    <div className='app-container'>
      <header>
        <div className='header-width-clamp'>
          <div className='site-id'>
            <NavLink to='/'><img src={Logo} width='40' style={{ background: '#0be476', borderRadius: '100%' }} /></NavLink>
          </div>
          <nav>
            <ul>
              <li><NavLink to='/projects'>Projects</NavLink></li>
              <li><NavLink to='/faq'>FAQ</NavLink></li>
            </ul>
          </nav>
        </div>
      </header>

      <main>
        <Route path='*' component={Breadcrumb} />
        <div>
          <Route path='*' component={TabbedView} />
        </div>
      </main>
      <footer>All rights reserved © 2018</footer>
    </div>
  </Router>,
  document.getElementById('root') as HTMLElement
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.tsx